import api from "../../../settings/api";
import { clearString } from "../../../utils/functions";
import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, PutEffect } from "redux-saga/effects";

export interface Fetch {
    plate: string;
    callback: (success: boolean, code?: string) => void;
}

export interface RequestDebtsAction {
    type: string;
    payload: Fetch;
}

export default function* requestDebts({
    payload,
}: RequestDebtsAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {
        const data = {
            licensePlate: clearString(payload.plate)?.toLocaleUpperCase(),
        };
        const response = yield call(api.post, `/v1/vehicle-debts/start`, data);

        if (response?.data?.data) {
            yield call(payload.callback, true, response?.data?.data);
        } else {
            yield call(payload.callback, false, "error");
        }

    } catch (error) {
        yield call(payload.callback, false, "timeout");
    }
}